export { CashPageContent } from './page-content';
